import { render, staticRenderFns } from "./ExternalLinkIcon.vue?vue&type=template&id=95ebce10&scoped=true&"
import script from "./ExternalLinkIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ExternalLinkIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ebce10",
  null
  
)

export default component.exports